import { Plugin } from 'prosemirror-state';
var createCtrlPlugin = function (spec, ctrlCenter) {
    var ctrlPlugin = new Plugin(spec);
    ctrlPlugin.props = spec.props;
    ctrlPlugin.registerProps = function (props, prioritized) { return ctrlCenter.register(props, prioritized); };
    ctrlPlugin.unregisterProps = function (props) { return ctrlCenter.unregister(props); };
    return ctrlPlugin;
};
export { createCtrlPlugin };
//# sourceMappingURL=index.js.map